import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../services/admin.service';
import { UserIdleService } from 'angular-user-idle';
import { UtilityService } from '../services/utility.service';
import { UserService } from '../services/user.service';
import { Users } from '../models/users';
import { RSAHelper } from '../models/RSAHelper';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

  isError: boolean = false;
  loading = false;
  user: Users;
  private initDone = false;  // <--- prevent repeated navigation
  generalInfoID: number = 0;
  pageType: string = "";
  ping_un: string = "";
  ping_em: string = "";

  constructor(
    private route: ActivatedRoute, 
    public authorizationService: AuthorizationService,
    public restApi: AdminService, 
    private userIdle: UserIdleService,
    private _utilityService: UtilityService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const codevalue = params['code'];
      if (!codevalue) return;

      // Store Ping code
      localStorage.setItem('pingID_code', codevalue);

      // Complete authorization request
      this.authorizationService.completeAuthorizationRequest(codevalue).then((tokenResponse) => {
        sessionStorage.removeItem('ping_un');    
        sessionStorage.removeItem('momaccesstoken')
        sessionStorage.setItem('momaccesstoken', tokenResponse.accessToken);
        
        localStorage.setItem('isPingUser', 'True');

        // Only process once
        if (!this.initDone) {
          this.initDone = true;
          this.checkValidSession();
        }

        // Optional: clear query params so reloads don't retrigger logic
        this.router.navigate([], { queryParams: {} });
      });
    });
  }

  checkValidSession() {
    this.restApi.verifyPingAccessToken().subscribe(
      (result: any) => {
        const objRSAHelper = new RSAHelper();
        this.ping_un = objRSAHelper.encryptWithPublicKey(result.email.trim());
        sessionStorage.setItem('ping_un', this.ping_un);

        if (result.active) {
          this.authorizedUser();
        } else {
          sessionStorage.removeItem('ping_un');
          this.userService.logout();
        }
      },
      (error) => {
        // handle error silently or log
        this.userService.logout();
      }
    );
  }

  authorizedUser() {
  let objusers = new Users();
  this.isError = false;
  objusers.tenantUno = 1;
  this.loading = true;

  this.restApi.pingUserAuthenticate(objusers).subscribe(
    data => {
      const rtndata: any = data;
      const objdata: any = rtndata.data[0];
      this.user = objdata;
      this.isError = !!objdata.error;

      if (!this.isError) {
        // Store access token
        sessionStorage.setItem('accessinfo', JSON.stringify({ token: objdata.token }));
        objusers.emailId = objdata.emailId;
        objusers.userName = objdata.userName;

        // Load full user info
        this.restApi.GetUserInfo_ByUserIDPing(objusers).subscribe(
          (data: any) => {
            if (data && data.length > 0 && data[0]) {
              const userData = data[0];
              const role = userData.role ? Number(userData.role) : 0;
              const picture = userData.picture || '';

              // Store user info
              localStorage.setItem('userinfo', JSON.stringify({
                id: userData.id,
                displayname: userData.displayName || '',
                username: userData.userName || '',
                firstname: userData.firstName || '',
                lastname: userData.lastname || '',
                email: userData.emailId || '',
                isTBT: userData.isTBT || false,
                division: userData.division || '',
                picture: picture,
                role: role,
                designation: userData.designation || '',
                userPRnumber: userData.userPRnumber || ''
              }));

              // Update profile photo
              this.userService.changeMemberPhoto(picture);
              const imgprof: any = document.getElementById("imgProfile");
              if (imgprof) imgprof.src = picture;

              // --- Dynamic Header Logo Logic ---
              const userEmail = userData.emailId || '';
              let headerImage = '';
              let logoIndex = 0;

              if (userEmail.includes("@digitalx.gov.ae")) {
                headerImage = this.userService.digitalxLogo;
                logoIndex = 1;
              } 
              else if (userEmail.includes("@digitaldewa.gov.ae")) {
                headerImage = this.userService.digitalDewaLogo;
                logoIndex = 2;
              } 
              else if (userEmail.includes("@morohub.com")) {
                headerImage = this.userService.moroLogo;
                logoIndex = 3;
              } 
              else if (userEmail.includes("@infrax.ae")) {
                headerImage = this.userService.infraxLogo;
                logoIndex = 4;
              } 
              else {
                headerImage = this.userService.dewaLogo;
                logoIndex = 0;
              }

              this.userService.changeHeaderLogo(headerImage, logoIndex);
              this.userService.headerLogo = headerImage;
              localStorage.setItem('headerLogo', headerImage);
              // --- End Header Logo Logic ---

              setTimeout(() => {
                this.loading = false;
                this.initServiceCalls();
                this.toggleRoleElements(role);
              }, 1000);

              this.getGroup();
            } else {
              this.loading = false;
              this.router.navigate(['/accessdenied']);
            }
          },
          error => {
            this.loading = false;
            this.router.navigate(['/accessdenied']);
          }
        );
      } else {
        this.loading = false;
        this.router.navigate(['/accessdenied']);
      }
    },
    error => {
      this.loading = false;
      this.router.navigate(['/accessdenied']);
    }
  );
}

  initServiceCalls() {
    // Navigate only once
    if (this.initDone) {
      this.userIdle.startWatching();
      if (this.generalInfoID > 0 && localStorage.getItem('userinfo')) { 
        this.router.navigate(['/view-page'], { queryParams: { QMId: btoa(this.generalInfoID.toString()), QMType: btoa(this.pageType) } });
      } else {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  toggleRoleElements(role: number) {
    const elementSideBarReport = document.getElementById('sideBarReport') as HTMLInputElement;
    if (elementSideBarReport) elementSideBarReport.style.display = (role == 1) ? "block" : "none";

    const elementSideBarSettings = document.getElementById('sideBarSettings') as HTMLInputElement;
    if (elementSideBarSettings) elementSideBarSettings.style.display = (role == 1) ? "block" : "none";

    const elementHeaderSettings = document.getElementById('headerSettings') as HTMLInputElement;
    if (elementHeaderSettings) elementHeaderSettings.style.display = (role == 1) ? "block" : "none";
  }

  getGroup() {
    this._utilityService.setProfileObs("login success");
  }
}
